import { Plus } from "lucide-react";

// Native <details> accordion: zero JS, fully crawlable, accessible by default.
export default function FaqList({ faqs, testid = "faq-list" }) {
  return (
    <div className="divide-y divide-[var(--line)] border-y border-[var(--line)]" data-testid={testid}>
      {faqs.map((f, i) => (
        <details key={f.question} className="faq-item group" name={testid}>
          <summary
            className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left text-base md:text-[17px] font-semibold text-[var(--ink)] hover:text-[var(--sage)] transition-colors"
            data-testid={`${testid}-trigger-${i}`}
          >
            {f.question}
            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-[var(--line)] transition-all duration-300 group-open:rotate-45 group-open:bg-[var(--sage)] group-open:border-[var(--sage)] group-open:text-white">
              <Plus className="h-4 w-4" />
            </span>
          </summary>
          <div className="faq-body pb-5 pr-12 text-[15px] leading-relaxed text-body">{f.answer}</div>
        </details>
      ))}
    </div>
  );
}
